import { forwardRef, useMemo } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useMediaQuery } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Close from '@material-ui/icons/Close';

import { useTheme } from '@material-ui/core/styles'

function getAdminLabel(admin) {
	return admin.name ? admin.name : `${admin.firstname} ${admin.lastname}`
}

export default function SelectAssignAdminModal({
	open,
	onClose,
	handleButton,
	onChangeCheckerAdminID,
	checkerAdminList,
	checkerAdminID,
}) {
	const theme = useTheme()
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

	const selectedAdmin = useMemo(
		() => checkerAdminList.find(admin => admin.id === checkerAdminID) || null,
		[checkerAdminList, checkerAdminID]
	)

	const handleAutocompleteChange = (_event, newValue) => {
		onChangeCheckerAdminID({
			target: { value: newValue ? newValue.id : '' },
		})
	}

	return (
		<Dialog
			maxWidth="sm"
			fullWidth
			fullScreen={fullScreen}
			onClose={onClose}
			open={open}
			TransitionComponent={Transition}>
			<DialogTitle style={{ backgroundColor: '#a74345' }}>
				<Grid
					container
					direction="row"
					justifyContent="space-between"
					alignItems="center">
					<Grid className="flex flex-row items-center" component="div">
						<Grid className="text-white text-lg">เลือกผู้ตรวจสอบข้อมูล</Grid>
					</Grid>
					<IconButton onClick={onClose} style={{ color: '#fff' }}>
						<Close />
					</IconButton>
				</Grid>
			</DialogTitle>
			<DialogContent dividers>
				<Grid className="flex flex-col justify-center items-center py-8 w-full">
					<Autocomplete
						className="w-5/6"
						options={checkerAdminList}
						getOptionLabel={getAdminLabel}
						getOptionSelected={(option, value) => option.id === value.id}
						value={selectedAdmin}
						onChange={handleAutocompleteChange}
						noOptionsText="ไม่พบรายชื่อที่ค้นหา"
						renderInput={(params) => (
							<TextField
								{...params}
								label="ค้นหารายชื่อผู้ตรวจข้อมูล"
								variant="outlined"
								placeholder="พิมพ์ชื่อเพื่อค้นหา..."
							/>
						)}
					/>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Grid
					container
					justifyContent="flex-end"
					alignItems="center"
					component="div">
					<Grid item className="p-3" style={{ minWidth: 160 }} component="div">
						<Button
							fullWidth
							onClick={handleButton}
							color="secondary"
							variant="contained"
							disabled={!checkerAdminID}>
							ยืนยันการเลือก
						</Button>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	)
}

const Transition = forwardRef(function Transtition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})
